import styled from 'styled-components';

export const CardContent = styled.div`
	padding: 4px;
`;

export const FilterPanel = styled.div`
  flex: 1 1 auto;
  // margin-bottom: 20px;
  // margin-left: 25px;
  // margin-right: 25px;
`;

export const MarginLeftAuto = styled.div`
	margin-left: auto;
	margin-right: 4px;
`;
